import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { DxDataGridModule, DxTemplateModule } from "devextreme-angular";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { PanelsModule } from "src/app/shared/panels/panels.module";
import { FocusingModule } from "src/app/shared/ui/forms/inputs/focusing.module";
import { OopsChoiceValueModule } from "src/app/shared/ui/forms/inputs/oops-choice-value/oops-choice-value.module";
import { Select2Module } from "src/app/shared/ui/forms/inputs/oops-select2/select2.module";
import { UiModule } from "src/app/shared/ui/ui.module";
import { InsightDetailAttributeComponent } from "./insight-detail-attribute.component";

@NgModule({
    declarations: [
        InsightDetailAttributeComponent
    ],
    exports: [
        InsightDetailAttributeComponent
    ],
    imports: [
        ButtonsModule,
        BsDropdownModule,
        CollapseModule,
        CommonModule,
        FocusingModule,
        FormsModule,
        DxDataGridModule,
        DxTemplateModule,
        MatIconModule,
        NgbNavModule,
        OopsChoiceValueModule,
        PanelsModule,
        ReactiveFormsModule,
        Select2Module,
        UiModule
    ],
    providers: []
})
export class AttributeModule {    
}